import { Component, OnInit } from '@angular/core';
import {
    DateAdapter,
    MAT_DATE_LOCALE,
    provideNativeDateAdapter,
} from '@angular/material/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import { TitleService } from './core/common/services/title/title.service';
import { Language } from './core/user/user-data/user-settings/user-settings.types';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
    providers: [
        provideNativeDateAdapter(),
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    ],
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private readonly _titleService: TitleService,
        private readonly _translocoService: TranslocoService,
        private readonly _adapter: DateAdapter<unknown, unknown>
    ) {}

    ngOnInit(): void {
        this._titleService.unsetTitle();

        this._translocoService.langChanges$.subscribe((lang: string) => {
            moment.locale(lang);
            let locale = 'fr';

            if (lang === Language.english) {
                locale = 'en-gb';
            }

            this._adapter.setLocale(locale);
        });
    }
}
